import { Users } from "lucide-react";
import React from "react";
import { UserManagement } from "@/components/admin/UserManagement";
import { Button } from "@/components/ui/button";

/**
 * Step 3 — User Management (TYPE B: Optional Configuration)
 *
 * Shows an empty/informational state by default.
 * User clicks "Set Up Users Now" to expand the real settings page.
 * Has inline editor: yes.
 */
interface StepUserManagementProps {
  expanded: boolean;
  onExpand: () => void;
}

export const StepUserManagement: React.FC<StepUserManagementProps> = ({
  expanded,
  onExpand,
}) => {
  if (expanded) {
    return (
      <div className="p-6 h-full">
        <div className="rounded-lg border border-border bg-white overflow-auto max-h-[calc(100vh-200px)]">
          <UserManagement />
        </div>
      </div>
    );
  }

  return (
    <div className="p-6 flex items-center justify-center min-h-[60vh]">
      <div className="text-center max-w-md">
        {/* Icon */}
        <div className="w-16 h-16 rounded-2xl bg-primary/10 flex items-center justify-center mx-auto mb-5">
          <Users className="h-8 w-8 text-primary" />
        </div>

        {/* Heading */}
        <h3 className="text-lg font-semibold text-foreground mb-2">
          Invite Your Team
        </h3>

        {/* Description */}
        <p className="text-sm text-muted-foreground leading-relaxed mb-6">
          Add your finance team so they can access their forecasts and reports.
          You can do this now or come back to it later from{" "}
          <span className="font-medium text-foreground">
            Settings → User Management
          </span>
          .
        </p>

        {/* CTA */}
        <Button onClick={onExpand}>Set Up Users Now</Button>
      </div>
    </div>
  );
};
